function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.937 8.96h11.439c.069 0 .13.044.155.109a.166.166 0 01-.045.184l-5.774 5.083a.964.964 0 001.27 1.447L15.457 9.2a1.605 1.605 0 000-2.408L7.984.213a.964.964 0 00-1.27 1.447l5.773 5.084a.168.168 0 01-.11.293H.937a.962.962 0 000 1.925V8.96z"
});

function SvgHappyNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), _ref);
}

export default SvgHappyNext;